export default __webpack_public_path__ + "assets/media/ways-logo.png";